import { Button } from '@/lib/base/buttons/button';

/**
 * Chat send-failure banner. Renders in the proposal CONTENT region's banner
 * stack (ProposalDetailPanel, beside PartialExecutionBanner et al.) — the
 * footer holds only the chat input and the approve/reject buttons (task 4
 * part 2, 2026-09-01). Renders nothing without an error.
 */
export function ChatErrorBanner({
  error,
  isRetrying,
  onRetry,
  onClear,
}: {
  error: Error | null | undefined;
  /** Disables Retry while the resend is in flight. */
  isRetrying: boolean;
  onRetry?: () => void;
  onClear?: () => void;
}) {
  if (!error) {
    return null;
  }
  return (
    <div
      className='mx-3 mt-3 flex items-center gap-2 rounded-lg border border-error-300 bg-error-50 p-3 text-error-700 dark:border-error-700 dark:bg-error-900/30 dark:text-error-300 sm:mx-4 lg:mx-6'
      role='alert'
    >
      <svg
        xmlns='http://www.w3.org/2000/svg'
        className='size-5 shrink-0'
        fill='none'
        viewBox='0 0 24 24'
        stroke='currentColor'
      >
        <path
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth={2}
          d='M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
        />
      </svg>
      <span className='flex-1 text-sm'>We couldn't send the message</span>
      <div className='flex gap-2'>
        {onRetry && (
          <Button
            color='primary'
            size='sm'
            onClick={onRetry}
            isDisabled={isRetrying}
          >
            Retry
          </Button>
        )}
        {onClear && (
          <Button color='secondary' size='sm' onClick={onClear}>
            Dismiss
          </Button>
        )}
      </div>
    </div>
  );
}
